import { AxiosResponse } from "axios";
import { microserviceApiAxios } from "../../microservice-api.axios";
import { microserviceApiRoutes } from "../../microservice-api.routes";
import { IAgentGetPlansRes } from "./agents-plans-service.interface";

export const getAgentsPlans = (sponsor: string) => {
  const url = microserviceApiRoutes.v1.agents.plans.getList(sponsor);
  return microserviceApiAxios
    .get<Error, AxiosResponse<IAgentGetPlansRes>>(url)
    .then((res) => res.data);
};
